import queryString from 'query-string';

import type { ApiListingApplicationListingType } from '#/api/types/ApiListingApplicationListingType';
import type { ApiOrgId } from '#/api/types/ApiTypedId';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

import type { OrgDashboardApiListingApplicationMini } from './types/OrgDashboardApiListingApplicationMini';

type ApiResponse = {
  count: number;
  lastPage: number;
  listingApplications: OrgDashboardApiListingApplicationMini[];
  page: number;
  perPage: number;
};

type ApiQueryParams = {
  listingType: ApiListingApplicationListingType;
  listingId?: string;
  withPagination: true;
  page: number;
};

function mapResponse(r: ApiResponse) {
  return {
    count: r.count,
    lastPage: r.lastPage,
    listingApplications: r.listingApplications,
    page: r.page,
    perPage: r.perPage,
  };
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId, params: ApiQueryParams) => {
    const qs = queryString.stringify(params);
    return `/data/orgdashboard/${orgId}/listing-applications?${qs}`;
  },
  mapResponse,
});

// Exports

export const orgDashboardApiFetchListingApplicationsWithPagination =
  endpoint.createClientFetchFn();

export const orgDashboardApiIsomorphicFetchListingApplicationsWithPagination =
  endpoint.createIsomorphicFetchFn();
